import { render, staticRenderFns } from "./Comofunciona.vue?vue&type=template&id=2704c12e&"
import script from "./Comofunciona.vue?vue&type=script&lang=js&"
export * from "./Comofunciona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports